import React from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import style from "./dashboard.module.scss";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import proPic from "../../../assets/images/nophoto/no_photo.jpg";
import "./profile-data.css";
import { red } from "@mui/material/colors";
import { cyan } from "@mui/material/colors";
import VerifiedIcon from "@mui/icons-material/Verified";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { CurrencyDecimalFormatNew } from "../../helper";
import CurrencyLatestSeperator from "../../helper/currencyLatestSeperator";
import moment from "moment";

const Profiles = React.memo((props) => {
  console.log("Profiles", props);
  const navigate = useHistory();
  const Currency = useSelector((state) => state.curr);
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  return (
    <div
      className={`${
        currentTheme == "theme-dark"
          ? style.dark_mode_dashboard_pannel_box
          : style.dashboard_pannel_box
      }`}
    >
      {props.lodervalue && (
        <Row>
          <Col xl={4} lg={4} md={12}>
            <div className={style.profile_main_sec}>
              <div className={style.profile_main_img_bx}>
                <SkeletonTheme baseColor="#FF5733" highlightColor="#444">
                  <Skeleton circle={true} height={90} width={90} />
                </SkeletonTheme>
              </div>
              <div className={style.profile_main_txt_sc}>
                <div>
                  <SkeletonTheme baseColor="#202020" highlightColor="#444">
                    <Skeleton width={170} count={1} />
                  </SkeletonTheme>
                </div>
                <div>
                  <SkeletonTheme baseColor="#202020" highlightColor="#444">
                    <Skeleton width={100} count={1} />
                  </SkeletonTheme>
                </div>
                <div>
                  <SkeletonTheme baseColor="#202020" highlightColor="#444">
                    <Skeleton
                      width={120}
                      height={30}
                      count={1}
                      borderRadius={50}
                    />
                  </SkeletonTheme>
                </div>
              </div>
            </div>
          </Col>
          <Col xl={4} lg={4} md={12}>
            <div className={style.profile_soc_share_sec}>
              <div className={style.profilesoc_share_bx_hd}>
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  <Skeleton width={100} />
                </SkeletonTheme>
              </div>
              <div className={style.profilesoc_share_bx_row}>
                <div className={style.profilesoc_share_bx_ico}>
                  <SkeletonTheme baseColor="#202020" highlightColor="#444">
                    {[1, 2, 3, 4].map((items, index) => {
                      return (
                        <span
                          style={{ paddingLeft: "3px", paddingTop: "10px" }}
                        >
                          <Skeleton circle={true} height={30} width={30} />
                        </span>
                      );
                    })}
                  </SkeletonTheme>
                </div>
              </div>
            </div>
          </Col>
          <Col xl={2} lg={2} md={6}>
            <div className={style.profile_other_box}>
              <div className={style.profile_other_box_cnt}>
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  <Skeleton width={100} />
                </SkeletonTheme>
              </div>
              <div className={style.profile_other_box_cnt}>
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  <Skeleton width={100} />
                </SkeletonTheme>
              </div>
            </div>
          </Col>
          <Col xl={2} lg={2} md={6}>
            <div className={`${style.profile_other_box} border-0`}>
              <div className={style.profile_other_box_cnt}>
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  <Skeleton width={100} />
                </SkeletonTheme>
              </div>
              <div className={style.profile_other_box_cnt}>
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                  <Skeleton width={100} />
                </SkeletonTheme>
              </div>
            </div>
          </Col>
        </Row>
      )}
      {props.profile && (
        <Row>
          <Col xl={8} lg={8} md={12}>
            <div className={style.profile_main_sec}>
              <div className={style.profile_main_img_bx}>
                <img
                  src={
                    props.profile.user_photo ? props.profile.user_photo : proPic
                  }
                  alt="No Image"
                />
              </div>
              <div
                style={{
                  width: "18px",
                  height: "18px",
                  borderRadius: "50%",
                  backgroundColor: "lightgreen",
                  border: "2px solid white",
                  top: "50px",
                  left: "80px",
                  position: "absolute",
                }}
              ></div>

              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? style.dark_mode_profile_main_txt_sc
                    : style.profile_main_txt_sc
                }`}
              >
                <Row>
                  <Col md={6}>
                    <div className={style.welcomeMsg}>
                      <div
                        style={{
                          fontWeight: "bolder",
                          color: "#000",
                          fontSize: "20px",
                        }}
                      >
                        Welcome Back,&nbsp; {props.profile.full_name}!
                      </div>
                      &nbsp;&nbsp;
                      <div>
                        {/* {t("Common.kyc")} : */}
                        {props?.profile?.kyc_status ? (
                          <span className={style.Verified}>
                            {/* <svg viewBox="0 0 24 24" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="10" r="7" fill="#34A402" />
                            <path fill="#FFFFFF" d="M4.5 8.5L6.5 10.5L11.5 5.5" />
                          </svg> */}
                            <VerifiedIcon
                              sx={{ color: cyan[300] }}
                              fontSize="small"
                            />
                            {t("Common.verified")}
                          </span>
                        ) : (
                          <div>
                            <span className={style.notVerified}>
                              <CancelRoundedIcon
                                sx={{ color: red[500] }}
                                fontSize="small"
                              />{" "}
                              <small>{t("Common.notverified")}</small>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </Col>
                  <Col md={9}>
                    <div
                      className="data"
                      style={{ display: "flex", gap: "30px", padding: "10px" }}
                    >
                      <div>
                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515", fontSize: "13px" }}>
                            Registration Date:
                          </b>{" "}
                          {/* {props.profile.regDate} */}
                          {moment
                            .utc(props.profile.regDate)
                            .subtract(8, "hours")
                            .tz("Asia/Manila")
                            // .format("MM/DD/YYYY h:mm:ss A")
                            .format("MM/DD/YYYY")}
                          {/* {props.profile.regDate} */}
                        </span>
                        {props.profile.accountType && (
                          <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                            <b style={{ color: "#151515" }}>Account Type:</b>{" "}
                            {props.profile.accountType}
                          </span>
                        )}

                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515" }}>Business Name:</b>{" "}
                          {props.profile.buisinessName}
                        </span>
                      </div>
                      <div>
                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515" }}>Primary:</b>{" "}
                          {props.profile.primary}
                        </span>
                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515" }}>Sponsor:</b>{" "}
                          {props.profile.sponsor}
                        </span>
                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515" }}>Placement:</b>{" "}
                          {props.profile.placement}
                        </span>
                      </div>
                      <div>
                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515" }}>Position:</b>{" "}
                          {props.profile.position}
                        </span>
                        <span style={{ color: "#A9A9A9", fontSize: "13px" }}>
                          <b style={{ color: "#151515" }}>
                            Registration Country:
                          </b>{" "}
                          {props.profile.regCountry}
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          {(props.profile.membership_package || props.profile.rank) && (
            <Col xl={2} lg={2} md={6}>
              <div
                className={`${
                  currentTheme == "theme-dark"
                    ? style.dark_mode_profile_other_box
                    : style.profile_other_box
                }`}
              >
                {props.profile.membership_package && (
                  <div
                    className={`${
                      currentTheme == "theme-dark"
                        ? style.dark_mode_profilesoc_share_bx_hd
                        : style.profilesoc_share_bx_hd
                    }`}
                  >
                    <span>
                      {/* {t("Dashboard.membershipPackage")} */}
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "bolder",
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        Account
                      </div>
                      <div
                        style={{
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          fontSize: "small",
                          color: "#151515",
                          textAlign: "center",
                        }}
                      >
                        {props.profile.membership_package.name ?? "NA"}{" "}
                      </div>
                    </span>
                  </div>
                )}

                <div style={{ textAlign: "center" }}>
                  <img
                    src={props.profile.membership_package.image}
                    // src={image1}
                    style={{
                      width: "100px",
                      height: "100px",
                      margin: "0 auto",
                    }}
                    alt=""
                  />
                </div>
              </div>
            </Col>
          )}
          <Col xl={2} lg={2} md={6}>
            <div
              className={`${
                currentTheme == "theme-dark"
                  ? style.dark_mode_profile_other_box
                  : style.profile_other_box
              }`}
            >
              {props.profile.rank && (
                <div
                  className={`${
                    currentTheme == "theme-dark"
                      ? style.dark_mode_profilesoc_share_bx_hd
                      : style.profilesoc_share_bx_hd
                  }`}
                >
                  <span>
                    {/* {t("Dashboard.membershipPackage")} */}
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "bolder",
                        textAlign: "center",
                      }}
                    >
                      {t("Rank")}
                    </div>
                    {props.profile.rank.curent_rank && (
                      <div
                        style={{
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          fontSize: "small",
                          color: "#151515",
                          textAlign: "center",
                        }}
                      >
                        {/* {props.profile.membership_package.name ?? "NA"}{" "} */}
                        {props.profile.rank.curent_rank ?? "NA"}{" "}
                      </div>
                    )}

                    {/* <strong>
                      {props.profile.rank.curent_rank ?? "NA"}{" "}
                    </strong> */}
                  </span>
                </div>
              )}
              <div style={{ textAlign: "center" }}>
                <img
                  src={props?.profile?.rank?.image}
                  // src={image2}
                  style={{
                    width: "100px",
                    height: "100px",
                    alignContent: "center",
                    marginTop: "10px",
                  }}
                  alt=""
                />
              </div>

              <h5 style={{ textAlign: "center" }}>
                {" "}
                {Currency.currentCurr}{" "}
                {CurrencyLatestSeperator(
                  props?.profile?.rank?.total_incentive * Currency.value,
                  Currency.precision
                )}
                {}
              </h5>
              <div
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                <span
                  onClick={() => {
                    navigate.push("/incentive-details");
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Total Rank Advance Incentive Earned
                </span>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
});
export default Profiles;
